<template>
  <!-- <Base v-if="id ==='D04'" :popInKr="true"/> -->
  <div v-if="isPC" class="content-area">
    <div class="layout-wrapper">
      <div class="left-part">
        <CompanyInfo :productInfo="productInfo" :popInKr="true" />
      </div>
      <div class="right-part">
        <CompanyProduct :productInfo="productInfo" :popInKr="true" :picts="resources" />
      </div>
    </div>
    <!-- 解说icon -->
    <span v-if="isIdle" class="speak-item speak-idle-icon" @click="playAudio"></span>
    <span v-else class="speak-item speak-play-icon" @click="stopAudio"></span>
    <audio v-if="audioArr.length > 0" ref="audioItem" :src="audioArr[0].url" loop="false" preload autoplay
      style="width: 0px; height: 0px; display: none;"></audio>
  </div>
  <div v-else class="m-content-area">
    <div class="m-layout-wrapper">
      <div class="m-left-part">
        <CompanyInfo :productInfo="productInfo" :popInKr="true" />
      </div>
      <div class="m-right-part">
        <CompanyProduct :productInfo="productInfo" :popInKr="true" :picts="resources" />
      </div>
    </div>
    <!-- 解说icon -->
    <span v-if="isIdle" class="speak-item speak-idle-icon" @click="playAudio"></span>
    <span v-else class="speak-item speak-play-icon" @click="stopAudio"></span>
    <audio v-if="audioArr.length > 0" ref="audioItem" :src="audioArr[0].url" loop="false" preload autoplay
      style="width: 0px; height: 0px; display: none;"></audio>
  </div>
</template>

<script>
import CompanyInfo from '@/common/CompanyInfo'
import CompanyProduct from '@/common/CompanyProduct'
import axios from 'axios'
// import Base from '@/common/Base'
const ShowType = {
  edu: 'edu', // 区教育局
  station: 'site', // 工作站
  exam: 'base', // 基地 with logo
  company: 'org', // 企业 with logo
}
export default {
  name: 'SearchEduCompanyDetail',
  components: { CompanyInfo, CompanyProduct, },
  props: ['subpath', 'detail'],
  data() {
    return {
      productInfo: {},
      audioArr: [],
      resources: [],
      isIdle: true,
    }
  },
  mounted() {

    axios.get('https://thumbsup-qbh-java-igdpvltehu.cn-shanghai.fcapp.run/show/refreshPraiseNew').then((response) => {
      if (response.data.status === 'success') {
        // this.totalLikeNew = response.data.data;
        this.$setItem('_totalLike', response.data.data);
        this.initData()
      }

    })
  },
  methods: {
    initData() {
      let showType = ShowType[this.subpath]
      if (showType) {
        let data = this.$allData[this.currentLang] || []
        for (let item of data) {
          if (item.boothNo === this.detail && item.showType === showType) {
            item = this.transformData(item)
            this.productInfo = item
            break
          }
        }
      }
    },
    transformData(itemInfo) {
      let imgs = itemInfo.pictures || []
      let videos = itemInfo.videoInfos || []
      let audois = itemInfo.voiceInfos || []

      let resources = []
      let audioArr = []
      for (let i = imgs.length - 1; i >= 0; i--) {
        let item = imgs[i]
        if (item.useFor && item.useFor === 'logo') {
          // get logo
          item.filePath && (itemInfo._logo = item.filePath)
        } else if (item.useFor && item.useFor === 'national_flag') {
          // 国旗
          item.filePath && (itemInfo._flag = item.filePath)
        } else {
          item.filePath && resources.splice(0, 0, {
            type: this.guessType(item.filePath),
            url: item.filePath
          })
        }
      }
      // 视频处理
      for (let video of videos) {
        video.filePath && resources.push({
          type: 'video',
          url: video.filePath.split('/').map((i) => {
            if (i.indexOf('.mp4') !== -1) {
              i = encodeURIComponent(i)
            }
            return i
          }).join('/')
        })
      }
      // 音频处理
      for (let au of audois) {
        au.filePath && audioArr.push({
          type: 'audio',
          url: au.filePath
        })
      }
      // pdf 处理
      if (itemInfo.innovateResults) {
        resources.push({
          type: 'pdf',
          url: itemInfo.innovateResults
        })
      }
      let self = this

      this.audioArr = audioArr
      this.resources = resources
      if (this.audioArr.length > 0) {
        this.$nextTick(() => {
          setTimeout(function () {
            self.checkAudioStatus()
          }, 1000)
        })
      }
      return itemInfo
    },
    guessType(filePath) {
      if (filePath.indexOf('.mp4') >= 0) {
        return 'video'
      } else if (filePath.indexOf('.pdf') >= 0) {
        return 'pdf'
      } else {
        return 'img'
      }
    },
    playAudio() {
      this.$refs.audioItem && this.$refs.audioItem.play()
      this.isIdle = false
    },
    stopAudio() {
      this.$refs.audioItem && this.$refs.audioItem.pause()
      this.isIdle = true
    },
    checkAudioStatus() {
      if (this.$refs.audioItem && this.$refs.audioItem.paused) {
        this.isIdle = true
      } else {
        this.isIdle = false
      }
    },
    back() {
      this.$parent.subpath = ''
      this.$parent.detail = ''
    },
    nTos(m) { return (parseInt(m, 10) < 10) ? '0' + String(parseInt(m, 10)) : String(parseInt(m, 10)) }
  }
}
</script>

<style scoped>
.content-area {
  width: 100%;
  min-height: 400px;
}

.layout-wrapper {
  width: 120rem;
  margin: 0 auto;
  font-size: 0px;
}

.left-part {
  width: 36rem;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  font-size: 16px;
}

.right-part {
  width: 84rem;
  display: inline-block;
  vertical-align: top;
  font-size: 16px;
}

.speak-item {
  display: inline-block;
  cursor: pointer;
  width: 5rem;
  height: 5.8rem;
  position: fixed;
  left: 48.7rem;
  bottom: 22rem;
  background-size: 100% 100%;
  transform: scale(2);
}

.speak-idle-icon {
  background-image: url("https://cdnzyzs.secsa.cn/qingbohuizs/2024/idle-1.gif");
}

.speak-play-icon {
  background-image: url("https://cdnzyzs.secsa.cn/qingbohuizs/2024/speak-2.gif");
}

.m-content-area {
  width: 100%;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
}

.m-layout-wrapper {
  width: 100%;
  height: 100%;
}
</style>